import { useQuery } from '@tanstack/react-query';
import { integrationsApi } from '../api/integrations';

export function useIntegrations() {
  return useQuery({
    queryKey: ['integrations'],
    queryFn: integrationsApi.list,
    refetchInterval: 45_000,
  });
}
